import { styled, Tab } from '@mui/material';

export const sxStyles = {
  bg: {
    backgroundColor: '#F9F9F9',
    height: '100%',
  },
  tableWrap: {
    padding: '2rem 2.5rem',
  },
};

export const StyledTab = styled(Tab)(() => ({
  maxWidth: '50%',
  width: '50%',
  fontSize: '0.938rem',
  fontWeight: 500,
  height: '54px',
}));
